import { AiFillHeart, AiFillCreditCard } from 'react-icons/ai'
import { FaShareAlt, FaMapMarkerAlt, FaPhoneAlt } from 'react-icons/fa'
import {
  BiWebcam,
  BiSupport,
  BiDollarCircle,
  BiArrowBack,
} from 'react-icons/bi'
import {
  IoMdArrowDropdown,
  IoIosArrowBack,
  IoIosArrowForward,
  IoMdRefresh,
} from 'react-icons/io'
import { ImArrowRight2, ImArrowUpRight2 } from 'react-icons/im'
import {
  BsFillEnvelopeFill,
  BsFillExclamationCircleFill,
  BsSearch,
  BsCircle,
  BsCircleFill,
  BsCheck,
  BsFillCaretDownFill,
  BsFillCaretUpFill,
  BsFillArrowRightCircleFill,
  BsFillArrowLeftCircleFill,
  BsArrowRightSquareFill,
} from 'react-icons/bs'
import { FiMoreHorizontal, FiMoreVertical, FiChevronDown } from 'react-icons/fi'
import { HiSelector, HiArrowRight, HiArrowLeft } from 'react-icons/hi'
import {
  FaChevronLeft,
  FaChevronRight,
  FaChevronUp,
  FaChevronDown,
} from 'react-icons/fa'
import {
  MdSlowMotionVideo,
  MdDone,
  MdPeople,
  MdClose,
  MdError,
  MdInfo,
  MdOpenInNew,
  MdContentCopy,
  MdSyncAlt,
} from 'react-icons/md'
import { GoDotFill } from 'react-icons/go'
import { VscGlobe } from 'react-icons/vsc'
import providerIcon from 'icons/provider-icon.json'
import filterIcon from 'icons/filter-icon.json'
import nextVector from 'icons/next-vector-icon.json'
import prevVector from 'icons/prev-vector-icon.json'
import upVector from 'icons/up-vector-icon.json'
import downVector from 'icons/down-vector-icon.json'
import smallProfileIcon from 'icons/small-profile-icon.json'
import smallTimeIcon from 'icons/small-time-icon.json'
import userTypeIcon from 'icons/user-type.json'
import childIcon from 'icons/child.json'
import someoneUserIcon from 'icons/help-user.json'
import userDependentIcon from 'icons/adult-dependent.json'
import calendar from 'icons/calendar.json'
import editIcon from 'icons/edit-icon.json'
import consentSign from 'icons/consent-agree-icon.json'
import pencilIcon from 'icons/pencil-icon.json'
import documentIcon from 'icons/document-icon.json'
import documentCheckboxIcon from 'icons/document-checkbox-icon.json'
import familyIcon from 'icons/family-icon.json'
import capsuleIcon from 'icons/capsule-icon.json'
import lifeCoachingIcon from 'icons/life-coaching-icon.json'
import deleteIcon from 'icons/delete-icon.json'
import rescheduleIcon from 'icons/reschedule-icon.json'
import addCalenderIcon from 'icons/add-calendar-icon.json'
import crossIcon from 'icons/cross.json'
import checkboxIcon from 'icons/checkbox-icon.json'
import greenCheck from 'icons/green-check.json'
import blueCheck from 'icons/blue-check.json'
import warning from 'icons/warning.json'
import chat from 'icons/chat.json'
import compass from 'icons/compass.json'
import community from 'icons/community.json'
import book from 'icons/book.json'
import buddy from 'icons/buddy.json'
import timmerIcon from 'icons/timer.json'
import benefits from 'icons/benefits.json'
import User from 'icons/user.json'
import location from 'icons/location.json'
import star from 'icons/star.json'
import pending from 'icons/pending.json'
import newCreditCard from 'icons/credit-card.json'
import couple from 'icons/couple-icon.json'
import individual from 'icons/individual.json'
import facebook from 'icons/facebook.json'
import tiktok from 'icons/tiktok.json'
import twitter from 'icons/twitter.json'
import linkedin from 'icons/linkedin.json'
import instagram from 'icons/instagram.json'
import youtube from 'icons/youtube.json'
import profit from 'icons/profit.json'
import nohassle from 'icons/nohassle.json'
import downArrow from 'icons/down-arrow.json'
import downArrowError from 'icons/down-arrow-error.json'
import upArrow from 'icons/up-arrow.json'
import circleCheck from 'icons/circle-check.json'
import search from 'icons/search.json'
import shield from 'icons/shield.json'
import cardHolder from 'icons/card-holder.json'
import pencilSimple from 'icons/pencil-simple.json'
import insuranceSheild from 'icons/insurance-shield-icon.json'
import videovisit from 'icons/videovisit.json'
import PracticeLocation from 'icons/PracticeLocation.json'
import shieldCheck from 'icons/shield-check.json'
import briefcase from 'icons/briefcase.json'
import pen from 'icons/pen.json'
import bookmark from 'icons/bookmark.json'
import medal from 'icons/medal.json'
import providerQNA from 'icons/provider-qna.json'
import aboutProvider from 'icons/about-provider.json'
import newspaper from 'icons/newspaper.json'
import viewCalendar from 'icons/view-calendar-icon.json'
import chatsCircle from 'icons/chats-circle.json'
import phone from 'icons/phone.json'
import filterArrowUp from 'icons/filter-caret-up.json'
import filterArrowDown from 'icons/filter-caret-down.json'
import filterCross from 'icons/filter-cross.json'
import bluePlus from 'icons/blue-plus.json'
import users from 'icons/users.json'
import hamburger from 'icons/hamburger-icon.json'
import callUsIcon from 'icons/call-us.json'
import searchGrey from 'icons/search-grey.json'
import lightCross from 'icons/light-cross.json'
import plus from 'icons/plus.json'
import addUser from 'icons/add-user.json'
import academicCap from 'icons/academic-cap.json'
import chatsOval from 'icons/chats-oval.json'
import calendarOutline from 'icons/calendar-outline.json'
import exclamationPoint from 'icons/exclamation-point.json'
import newSearch from 'icons/new-search-icon.json'
import lightFourSquare from 'icons/light_four_squares.json'

export const iconMapping = {
  calendarOutline: calendarOutline,
  chatsOval: chatsOval,
  academicCap: academicCap,
  addUser: addUser,
  webcam: BiWebcam,
  location: FaMapMarkerAlt,
  heart: AiFillHeart,
  provider: providerIcon,
  filter: filterIcon,
  nextVector: nextVector,
  prevVector: prevVector,
  upVector: upVector,
  downVector,
  back: BiArrowBack,
  share: FaShareAlt,
  smProfileIcon: smallProfileIcon,
  smTimeIcon: smallTimeIcon,
  viewCalendar,
  calendar: calendar,
  appointmentFor: userTypeIcon,
  creditCard: AiFillCreditCard,
  newCreditCard,
  cross: crossIcon,
  check: checkboxIcon,
  circleCheck,
  child: childIcon,
  someoneUser: someoneUserIcon,
  dependentUser: userDependentIcon,
  edit: editIcon,
  consentSign: consentSign,
  pencil: pencilIcon,
  document: documentIcon,
  family: familyIcon,
  capsule: capsuleIcon,
  documentCheckbox: documentCheckboxIcon,
  lifeCoaching: lifeCoachingIcon,
  delete: deleteIcon,
  reschedule: rescheduleIcon,
  addCalender: addCalenderIcon,
  refresh: IoMdRefresh,
  message: BsFillEnvelopeFill,
  phone: FaPhoneAlt,
  chat: chat,
  compass: compass,
  exclamationPoint,
  facebook,
  tiktok,
  twitter,
  linkedin,
  instagram,
  youtube,
  community: community,
  book: book,
  buddy: buddy,
  timer: timmerIcon,
  benefits: benefits,
  alert: BsFillExclamationCircleFill,
  user: User,
  Flocation: location,
  star,
  pending,
  couple,
  individual,
  copy: MdContentCopy,
  dropdownIcon: IoMdArrowDropdown,
  dot: GoDotFill,
  support: BiSupport,
  video: MdSlowMotionVideo,
  saving: BiDollarCircle,
  profit,
  easy: nohassle,
  globe: VscGlobe,
  search: BsSearch,
  done: MdDone,
  circle: BsCircle,
  filledCircle: BsCircleFill,
  downArrow,
  downArrowError,
  upArrow,
  rightArrow: HiArrowRight,
  leftArrow: HiArrowLeft,
  magnify: search,
  shield,
  iosBackLeft: IoIosArrowBack,
  iosBackRight: IoIosArrowForward,
  selector: HiSelector,
  tick: BsCheck,
  cardHolder,
  pencilSimple,
  insurance: insuranceSheild,
  videovisit,
  inperson: MdPeople,
  practiceLocation: PracticeLocation,
  shieldCheck,
  briefcase,
  pen,
  bookmark,
  medal,
  providerQNA,
  readMoreForward: ImArrowRight2,
  aboutProvider,
  newspaper,
  datePrevArrow: FaChevronLeft,
  dateNextArrow: FaChevronRight,
  toggleUpArrow: FaChevronUp,
  toggleDownArrow: FaChevronDown,
  greenCheck,
  blueCheck,
  warning,
  chatsCircle,
  phoneRight: phone,
  moreVertical: FiMoreVertical,
  moreHorizontal: FiMoreHorizontal,
  filterArrowUp,
  filterArrowDown,
  filterCross,
  bluePlus,
  users,
  close: MdClose,
  caretDown: BsFillCaretDownFill,
  caretUp: BsFillCaretUpFill,
  videoError: MdError,
  info: MdInfo,
  openInNew: MdOpenInNew,
  hamburger,
  callUsIcon,
  searchGrey,
  rightArrowCircle: BsFillArrowRightCircleFill,
  leftArrowCircle: BsFillArrowLeftCircleFill,
  upRightArrow: ImArrowUpRight2,
  lightCross,
  plus,
  arrowRightSquare: BsArrowRightSquareFill,
  iosDownRounded: FiChevronDown,
  newSearch,
  lightFourSquare,
  sync: MdSyncAlt,
}

// * WHEN ICON IS CUSTOM
// 1. convert your svg icon to json from here https://react-icons-json-generator.surge.sh/
// 2. include the name and the corresponding json to the iconMapping object

// * WHEN ICON IS FROM BOOTSTRAP
// 1. import the required icons from react-icons and map it to the iconMapping object with the name

export const getIcon = (iconValue: string): React.ReactNode => {
  if (!iconMapping[iconValue]) {
    throw new Error(
      `Icon name '${iconValue}' is not mapped, please follow steps to add it to mapping mentioned in file iconMappings.ts`
    )
  }

  return iconMapping[iconValue]
}
